export default __webpack_public_path__ + "static/char-v-48-7c49419d112fe9cb0cf8fb875d1710c4.png";